import {
  Component,
  OnInit,
  Input,
  ViewChild,
} from "@angular/core";
import { UntypedFormGroup, Validators, AbstractControl } from "@angular/forms";

import { Address } from "ngx-google-places-autocomplete/objects/address";
import { Options } from "ngx-google-places-autocomplete/objects/options/options";

import { ListItem, Resource, FormFieldType, ADPResourceService as ResourceService, NotificationService } from "digital-core";
import { NgxGooglePlacesDirective } from "common/directives/ngxGooglePlaces.directve";


@Component({
  selector: 'adp-google-places',
  templateUrl: './adp-google-places.component.html',
  styleUrls: ['./adp-google-places.component.css'],

})
export class adpGooglePlacesComponent implements OnInit {

  @Input()
  group: UntypedFormGroup

  @Input()
  options: Options

  @Input()
  componentName: string

  @Input()
  namespaceForMailingAddress: string;


  @Input()
  mailingAddressControlName: string;

  /*City*/
  @Input()
  cityControlName: string;

  @Input()
  cityResourceField: Resource;

  /*State */
  @Input()
  stateResourceField: Resource;

  @Input()
  stateControlName: string;

  /*Country */
  @Input()
  countryResourceField: Resource;

  @Input()
  countryControlName: string;

  /*Zip Code */
  @Input()
  zipCodeResourceField: Resource;

  @Input()
  zipCodeControlName: string;

  /*Mailing Address 2*/
  @Input()
  public mailingAddress2ResourceField: Resource;

  @Input()
  mailingAddress2ControlName: string;

  addressResourceInfo: Resource;
  addressField: AbstractControl;
  states: ListItem[] = [];
  countries: ListItem[] = [];
  parentComponentName: string;
  //googlePlacesOptions = {};
  showAddressLine2 = false;
  defaultTootipIcon:string='info_outline';
  @ViewChild("placesRef") placesRef?: NgxGooglePlacesDirective;
    googlePlacesOptions!: google.maps.places.AutocompleteOptions;
  constructor(
    public resourceService: ResourceService,
    public notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.googlePlacesOptions = {
      types: [],
      componentRestrictions: {
        country: this.resourceService.getPortalSetting("GoogleMap_AddressCountryRestriction")?.Value
      }
    };

    this.loadControls();
    this.updateStates();
    this.updateCountries();
    this.validateAddressLine2();
  }

  updateStates() {
    let scope = this;
    this.resourceService.getListItemResource("Global_List_State").subscribe(
      response => {
        scope.states = response.sort((a, b) => a.Value.toLowerCase() > b.Value.toLowerCase() ? 1 : -1);
      },
      error => {
        this.notificationService.logError(error);
      }
    );
  }

  updateCountries() {
    let scope = this;
    this.resourceService.getListItemResource("Global_List_Country").subscribe(
      response => {
        scope.countries = response.sort((a, b) => a.Value.toLowerCase() > b.Value.toLowerCase() ? 1 : -1);
        if (!!scope.countries && scope.countries.length === 1) {
          this.group.get(this.countryControlName).setValue(this.countries[0].Key)
        }
      },
      error => {
        this.notificationService.logError(error);
      }
    );
  }

  loadControls() {

    let nameSpace = this.namespaceForMailingAddress ? this.namespaceForMailingAddress : 'Global';
    this.resourceService
      .getFormFieldResource(nameSpace, FormFieldType.Field, "MailingAddress")
      .subscribe(response => {
        this.addressResourceInfo = response;
        this.initAddressControl();
      });
  }

  public handleAddressChange(address: Address) {
    if (address) {
      let streetNumber = address.address_components.find(x =>
        x.types.includes("street_number")
      );

      let street = address.address_components.find(x =>
        x.types.includes("route")
      );

      let _city = address.address_components.find(x =>
        x.types.includes("locality")
      );
      if (!_city) {
        _city = address.address_components.find(x =>
          x.types.includes("administrative_area_level_2")
        );
      }
      let _state = address.address_components.find(x =>
        x.types.includes("administrative_area_level_1")
      );
      let _country = address.address_components.find(x =>
        x.types.includes("country")
      );
      let _zip = address.address_components.find(x =>
        x.types.includes("postal_code")
      );

      this.group
        .get(this.mailingAddressControlName)
        .setValue(
          `${streetNumber ? streetNumber.long_name : ""} ${street ? street.long_name : ""
          }`
        );
      let stateIndex = this.states.findIndex(item => item.Key.toLowerCase() === _state.short_name.toLowerCase());
      if (_state && stateIndex > -1) {
        this.group
          .get(this.stateControlName)
          .setValue(_state ? _state.short_name : "");
      }
      let countryIndex = this.countries.findIndex(item => item.Key.toLowerCase() === _country.short_name.toLowerCase());
      if (_country && countryIndex > -1) {
        this.group
          .get(this.countryControlName)
          .setValue(_country ? _country.short_name : "");
      }
      this.group
        .get(this.cityControlName)
        .setValue(_city ? _city.long_name : "");
      this.group
        .get(this.zipCodeControlName)
        .setValue(_zip ? _zip.long_name : "");
    }
  }

  get AddressField(): AbstractControl {
    return this.group.get(this.mailingAddressControlName);
  }

  initAddressControl() {
    if (!this.addressResourceInfo) {
      throw new Error(
        "The resource information associated to the control doesn't exist."
      );
    }
    let formControl = this.AddressField;
    let validators = [];
    if (this.addressResourceInfo.IsRequired) {
      validators.push(Validators.required);
    }
    if (this.addressResourceInfo.MinValue && this.addressResourceInfo.MinValue >= 0) {
      validators.push(Validators.minLength(this.addressResourceInfo.MinValue));
    }
    if (this.addressResourceInfo !== null && this.addressResourceInfo !== undefined) {
      if (this.addressResourceInfo.MaxValue && this.addressResourceInfo.MaxValue >= 0) {
        validators.push(Validators.maxLength(this.addressResourceInfo.MaxValue));
      }
    }

    if (this.addressResourceInfo.ValidationRegex) {
      validators.push(
        Validators.pattern(this.addressResourceInfo.ValidationRegex)
      );
    }
    formControl.setValidators(validators);
  }

  getMailingAddressId() {
    return this.componentName.concat('_', this.mailingAddressControlName);
  }

  updateResource(resource) {
    if (resource) {
      this.addressResourceInfo = resource;
      this.ngOnInit();
    }
  }

  validateAddressLine2() {
    let address2 = this.group.get(this.mailingAddress2ControlName).value;
    if (address2 && address2 != "") {
      this.showAddressLine2 = true;
    }
  }

  addAddressLine2() {
    this.showAddressLine2 = true;
  }
}
